<div class="calendar">
  <div class="header">
    <ion-button (click)="goToPreviousYear()" class="nav-btn" [disabled]="isPreviousYearDisabled()">
      &#171;
    </ion-button>
    <ion-button (click)="goToPreviousMonth()" class="nav-btn" [disabled]="isPreviousMonthDisabled()">
      &#8249;
    </ion-button>
    <select [(ngModel)]="currentMonth" (change)="generateCalendar()" class="dropdown">
      <option *ngFor="let month of months" [value]="month.value" [disabled]="isMonthDisabled(month.value)">
        {{ month.name }}
      </option>
    </select>
    <select [(ngModel)]="currentYear" (change)="generateCalendar()"  class="dropdown">
      <option *ngFor="let year of years" [value]="year" [disabled]="isYearDisabled(year)">
        {{ year }}
      </option>
    </select>
    <ion-button (click)="goToNextMonth()" class="nav-btn" [disabled]="isNextMonthDisabled()">
      &#8250;
    </ion-button>
    <ion-button (click)="goToNextYear()" class="nav-btn" [disabled]="isNextYearDisabled()">
      &#187;
    </ion-button>
  </div>
  <div class="days">
    <div class="day" *ngFor="let day of weekDays">{{ day }}</div>
  </div>

  <div class="dates">
    <button class="date" *ngFor="let date of calendarDays" [class.today]="isToday(date)"
      [class.selected]="isSelectedDate(date)" [class.placeholder]="date.getTime() === 0"
      [disabled]="isDateDisabled(date)" (click)="selectDate(date)">
      {{ date.getTime() !== 0 ? date.getDate() : '' }}
    </button>
  </div>

  <!-- Add Today and Clear buttons -->
  <div class="actions d-flex justify-content-between mt-2">
    <ion-button class="filled-blue-btn" (click)="selectToday()">Today</ion-button>
    <ion-button class="unfilled-gray-btn" (click)="clearSelection()">Clear</ion-button>
  </div>
</div>